import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DialogsService } from '../../../framework/components/dialog/dialogs.service'
import { MatDialogRef } from '@angular/material'
import { ChangePinModel } from './change-pin.model'
import { AuthService } from '../../../framework/auth/auth.service';
import { ApiService } from '../../../framework/data/api.service';
import { FirestoreService } from '../../../framework/data/firestore.service';

@Component({
  selector: 'app-change-pin',
  templateUrl: './change-pin.component.html',
  styleUrls: ['./change-pin.component.scss']
})

export class ChangePinComponent implements OnInit {
  user: ChangePinModel = new ChangePinModel();

  hide1 = true;
  hide2 = true;
  hide3 = true;

  form: FormGroup;

  constructor(
    private api: ApiService,
    private firestore: FirestoreService,
    private dialogs: DialogsService,
    private ref: MatDialogRef<ChangePinComponent>,
  ) {

    this.form = new FormGroup({
      pin: new FormControl('', [Validators.minLength(4), Validators.required]),
      newPin: new FormControl('', [Validators.minLength(4), Validators.required]),
      confirm: new FormControl('', [Validators.minLength(4), Validators.required]),
    })

  }

  ngOnInit() {
    this.user.uId = AuthService.user.currentCredential.uId;
    this.firestore.doc(`user/${this.user.uId}`, ['pinCustomer'])
      .subscribe(user => this.user = user)
  }

  showDialog(): void {
    if (this.form.controls.pin.value !== this.user.pinCustomer) {
      this.dialogs.error('El PIN actual no es correcto.'); //, 'accent', 'close')
    } else {
      if (this.form.controls.newPin.value !== this.form.controls.confirm.value) {
        this.dialogs.error('Los PINs no coinciden'); //, 'accent', 'close')
      } else {
        this.updateNewPin()
      }
    }
  }
  updateNewPin() {
    const loading = this.dialogs.loading()
    //console.log( this.user.pinCustomer);
    this.user.pinCustomer = this.form.controls.newPin.value;
    this.api.postEncrypted('changePin',
      { body: { text: JSON.stringify({ uId: this.user.uId, pin: this.user.pinCustomer, appType: 'CUSTOMER' }) } },
      { body: ['text'] }
    ).subscribe( () => {
        loading.hide()
        this.dialogs.okConfirm('El cambio de pin se ha realizado correctamente').then(() => {
          this.ref.close()
        });
      },
      error => {
        this.dialogs.error(error.error.responseMessage)
        loading.hide()
      },
    )
  }

  getErrorNewPin() {
    return this.form.controls.newPin.hasError('required') ? 'Ingresa un nuevo PIN' :
      this.form.controls.newPin.hasError('minlength') ? 'El Pin es de 4 dígitos' :
        '';
  }

  getErrorConfPin() {
    return this.form.controls.confirm.hasError('required') ? 'Ingresa la confirmación del nuevo PIN ' :
      this.form.controls.confirm.hasError('minlength') ? 'El Pin es de 4 dígitos' :
        '';
  }

  clickHere(){
    this.ref.close()
  }
}
